<template>
    <ui-overlay-load v-if="loader.news" background-color-overlay="transparent" />
    <div v-else>
        <div class="article-header">
            <span class="back" @click="cancelAddNews">
                <i class="fal fa-chevron-left" />Voltar
            </span>
           
        </div>
        <div class="page-container">
            <article>
                <ui-card-toggle :shadow="4" :open="true" design="brightness" set-status>
                    <template #title>Informações básicas</template>
                    <template #content>
                        <ui-input v-model="form.title" label="Título" placeholder="Digite..." required size="xl" />
                        <h1 class="title">Descrição</h1>
                        <ui-text-editor
                            v-model="form.article"
                            placeholder="Digite..."
                        />
                    </template>
                </ui-card-toggle>
            </article>
            <aside>
                <ui-button
                    :disabled="!canSubmit"
                    design="success xl block"
                    @click="createOrEditNews"
                >
                    Salvar e publicar
                </ui-button>	
                <ui-card-toggle :shadow="4" set-status>
                    <template #title>Capa</template>
                    <template #content>
                        <ui-upload-image
                            v-model="uploadImage.data"
                            :image-url="uploadImage.imageUrl ? uploadImage.imageUrl : ''"
                        />
                        <span v-if="uploadImage.imageUrl" class="remove-image" @click="removeIMG()">
                            <i class="fal fa-trash-alt" />
                            Remover Imagem
                        </span>
                    </template>
                </ui-card-toggle>

                <ui-card-toggle :shadow="4" :isMark="teams.length > 0" set-status>
                    <template #title>Quem pode ler?</template>
					<template #mark>
						<div class="actions">
							<div class="actions-button" @click="allSelected()">
								{{ titleTomMarkToDesmark }}
							</div>
						</div>
					</template>
                    <template #content>
                        <ui-load-indicator
                            v-if="loader.teams"
                            :h="30"
                            :stroke="9"
                            class="loading-center"
                        />
                        <div v-else class="teams scroll-color">
                            <div v-for="team in teams" :key="team.id">
                                <ui-checkbox
                                    :id="team.id"
                                    :label="team.name"
                                    :checked="hasIncludesTeamForm(team.id)"
                                    design="sm"
									@input="checkButton(team.id)"
                                />
                            </div>
                        </div>
                    </template>
                </ui-card-toggle>

                <ui-card-toggle :shadow="4" set-status>
                    <template #title>Categoria</template>
                    <template #content>
                        <ui-load-indicator
                            v-if="loader.category"
                            :h="30"
                            :stroke="9"
                            class="loading-center"
                        />
                        <div v-else>
                            <div v-for="(item, index) in category.list" :key="item.id" class="radio-line" @mouseleave="showGear = null" @mouseenter="showGear = index">
                                <ui-radio
                                    :name="category.name"
                                    :label="item.name"
                                    :value="item.id"
									:checked="item.id == form.category_id"
                                    @input="radioHandler"
                                />
                                <div v-if="index !== 0 && showGear == index">
                                    <ui-menu-card
                                        icon="fal fa-cog"
                                        card-design="myDesign"
                                    >
                                        <button
                                            type="button"
                                            @click="handleDeleteCategory(item)"
                                        >
                                            Excluir
                                        </button>
                                    </ui-menu-card>
                                </div>
                            </div>
                            <div class="container-hr">
                                <div class="hr"/>
                            </div>
                            <div class="add-more">
                                <span @click="addMoreCategory">
                                    <i class="fal fa-plus" />Adicionar mais
                                </span>
                                <div v-if="showAddMore" class="add">
                                    <ui-input
                                        v-model="category.name"
                                        placeholder="Digite aqui o nome da categoria..."
                                        design="brr-off"
                                        :disabled="loader.categoryInput"
                                        @keyup.enter.native="createCategory"
                                    />
                                    <ui-button
                                        design="md primary brl-off"
                                        :loading="loader.categoryInput"
                                        :disabled="category.name.length < 4"
                                        @click="createCategory"
                                    >
                                        <i class="far fa-plus"/>
                                    </ui-button>
                                </div>
                            </div>
                        </div>
                    </template>
                </ui-card-toggle>
            </aside>
        </div>
        <ui-modal-message
            name="delete-category"
            service="news"
            :title="`Deseja realmente excluir a categoria '${categorySelectedName}' ?`"
            text="Cuidado, esta ação não poderá ser desfeita."
            btn-type="danger"
            btn-text="Confirmar"
            icon="fal fa-trash-alt"
            color-circle="danger"
            icon-circle
        />
    </div>
</template>

<script>
import { uiLoadIndicator, uiOverlayLoad, uiMenuCard } from '@/components/ui'
import { uiUploadImage } from '@/components/ui/upload'
import { uiInput, uiCheckbox, uiTextEditor, uiSwitch, uiRadio } from '@/components/ui/form'
import { uiCardToggle } from '@/components/ui/cards'
import { uiButton } from '@/components/ui/buttons'
import { uiModalMessage } from '@/components/ui/modal'
import { news, offline, files } from '@/services/axios'
import { helpersMixin, utilMixin }from '@/mixins'

const defaultLoader = () => ({
	news: false,
	category: true,
	categoryDelete: false,
	categoryInput: false,
	teams: true,
})

export default {
	name: 'news-add-edit',

	components: {
		uiLoadIndicator,
		uiOverlayLoad,
		uiUploadImage,
		uiInput,
		uiCheckbox,
		uiTextEditor,
		uiCardToggle,
		uiButton,
		uiSwitch,
		uiRadio,
		uiMenuCard,
		uiModalMessage,
	},

	mixins: [helpersMixin, utilMixin],

	data() {
		return {
			loader: { ...defaultLoader() },
			uploadImage: {
				formData: null,
				imageId: null,
				imageUrl: null,
				data: null
			},
			category: { selectedId: null, name: '', list: [] },
			teams: [],
			showAddMore: false,
			categorySelectedName: null,
			showGear: null,
			form: {
				title: null,
				article: null,
				category_id: null,
				cover_id: null,
				teams_permissions: [],
			}
		}
	},
	computed: {
		canSubmit () {
			return (
				this.$mx_hasValue(this.form.title 	  		 ) &&
				this.$mx_hasValue(this.form.teams_permissions) && 
				this.$mx_hasValue(this.form.category_id 	 ) &&
				this.$mx_hasValue(this.form.article	 		 )
			)
		},

		titleTomMarkToDesmark() {
			return this.form.teams_permissions.length === this.teams.length ? "Desmarcar todos" : "Selecionar todos"
		}	
	},

	async mounted() {
		this.loader.news = true
		await this.getCategory()
		await this.getTeams()

		if (this.$route.params.id) {
			await this.getNews()
		}
		
		this.loader.news = false
		this.$root.$on('news-refresh-categories', (data, id) => {
			this.category.list =  this.category.list.filter(val => val.id != id)
		})
	},

	beforeDestroy() {
		this.$root.$off('news-refresh-categories')
	},

	methods: {
		removeIMG() {
			this.uploadImage = {
				formData: null,
				imageId: null,
				imageUrl: null,
				data: null
			},
			this.form.cover_id = null
		},

		checkButton(val) {
			let index = this.form.teams_permissions.indexOf(val)
			if(index === -1) {
				this.form.teams_permissions.push(val)
			} else {
				this.form.teams_permissions.splice(index, 1)
			}
		},

		hasIncludesTeamForm(val) {
			return this.form.teams_permissions.includes(val)
		},

		async getCategory() {
			try {
				this.loader.category = true
				this.form.category_id = null
				this.category.list = []
				const response = await news.getAllV2('/category')
				this.category.list = response.data
				this.loader.category = false
			} catch (e){
				this.loader.category = false
				if(e?.message === undefined) {
					return
				}
				this.$toastr.e('Não foi possível carregar as categorias de novidade!')
			}
		},

		async getTeams() {
			try {
				const response = await offline.getTeams()
				this.teams = response.data
				this.loader.teams = false
			} catch {
				this.$toastr.e('Não foi possível carregar os times do sistema!')
				this.loader.teams = false
			}
		},
		async getNews() {
			try {
				const response = await news.getAllV2(`${this.$route.params.id}/edit`)
				if (response.data) {
					this.form.title 	  = response.data.title
					this.form.article 	  = response.data.article
					this.form.category_id = response.data.category.id

					this.uploadImage.data = true
					if (response.data.cover_id) this.form.cover_id = response.data.cover_id
					if (response.data.cover) this.uploadImage.imageUrl = response.data.cover.url

					// Get the selected teams for this news
					if (response.data.permissions) {
						for(const key in response.data.permissions) {
							this.form.teams_permissions.push(response.data.permissions[key].id)
						}
					}
				}
			} catch {
				// Something went wrong, the news with this id doesn't exist or the API is broken
				this.$toastr.e('Não foi possível carregar a edição desta novidade!')
				this.$router.push({ name: 'news.list' })
			}
		},
		async uploadImageToCDN() {
			if (!this.uploadImage.data || this.uploadImage.data == true) return

			try {
				const response = await files.create('', this.uploadImage.data)
				this.form.cover_id = response.data[0].file.id
			} catch {
				this.$toastr.e('Não foi possível fazer o upload da imagem, tente novamente!')
			}
		},
	
		async createOrEditNews() {
			try {
				this.loader.news = true
				await this.uploadImageToCDN()
				await news.createV2(this.$route.params.id ? `/${this.$route.params.id}` : '', this.form)

				this.loader.news = false
				this.$router.push({ name: 'news.list' })
			} catch {
				this.$route.params.id
					? this.$toastr.e('Não foi possível editar a novidade, tente novamente!')
					: this.$toastr.e('Não foi possível adicionar a novidade, tente novamente!')
				this.loader.news = false
			}
		},
		async createCategory() {
			if (this.category.name.length < 4) {
				this.$toastr.e('O nome da categoria deve ter no mínimo 4 caracteres...')
				return
			}

			try {
				this.loader.categoryInput = true
				const response = await news.createV2('/category', { name: this.category.name })

				this.category.list.push(response.data.data)
				this.form.category_id = response.data.data.id
				this.category.name = ''

				this.loader.categoryInput = false
			} catch {
				this.$toastr.e(
					`Não foi possível adicionar a categoria '${this.category.name}', tente novamente!`
				)
				this.loader.categoryInput = false
			}
		},
		allSelected() {
			if(this.form.teams_permissions.length === this.teams.length) return this.form.teams_permissions = []
			for(const key in this.teams) {
				if(!this.form.teams_permissions.includes(this.teams[key].id)) this.form.teams_permissions.push(this.teams[key].id)
			}
		},

		cancelAddNews() {
			this.$router.push({ name: 'news.list' })
		},

		addMoreCategory() {
			this.showAddMore = !this.showAddMore
		},

		radioHandler(value) {
			this.form.category_id = value
		},
		
		handleDeleteCategory(value) {
			this.categorySelectedName = value.name
			// this.$root.$emit(`modal-msg-open-delete-category-${this.categorySelected}`)
			this.$root.$emit('modal-msg-open-delete-category', { 
				method: 'deleteV2',
				url: 'category',
				id: value.id,
				eventSuccess: 'news-refresh-categories'
			})
		},
	},
}
</script>
<style lang="stylus" scoped>
@import 'styles.styl';
</style>
